var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"sortable-handle",staticStyle:{"cursor":"move","width":"20px"}},[_c('v-icon',{staticClass:"dots",attrs:{"color":"grey"}},[_vm._v("la-ellipsis-v")]),_c('v-icon',{staticClass:"dots",attrs:{"color":"grey"}},[_vm._v("la-ellipsis-v")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }